<template>
  <div>
    <eb-header>
      <eb-break-crumb slot="breakCrumb" />
      <eb-search @search-click="searchData" slot="search" />
    </eb-header>
    <div class="box-header">
      <div class="box-header-right">
        <el-button @click="downloadCsv" class="eb-button-red eb-button-small">下载csv</el-button>
        <el-button :disabled="isPushStatus" @click="onBusinessConfig(1)" class="eb-button-red eb-button-small">暂停接收</el-button>
        <el-button :disabled="isPushStatus" @click="onBusinessConfig(0)" class="eb-button-red eb-button-small">启动接收</el-button>
      </div>
    </div>
    <div class="table-box">
      <div class="eb-table">
        <el-table :data="tableData" :stripe="true" row-key="businessPushId" @selection-change="handleSelectionChange" ref="pushListRef"
          style="width: 100%">
          <el-table-column :reserve-selection="true" type="selection" width="40"></el-table-column>
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column sortable prop="supplierUserName" label="订购人" width="90"></el-table-column>
          <el-table-column sortable prop="supplierDepartName" label="所属机构"></el-table-column>
          <el-table-column sortable prop="buyerDepartName" label="被订购机构" width="120"></el-table-column>
          <el-table-column sortable prop="orderAmount" label="交易金额" width="100"></el-table-column>
          <el-table-column sortable prop="pushStartDate" label="订购日期" width="100"></el-table-column>
          <el-table-column sortable prop="pushEndDate" label="到期时间" width="100"></el-table-column>
          <el-table-column sortable prop="pushStatus" label="推送状态" width="100"></el-table-column>
          <el-table-column sortable prop="sysOrderNumber" label="订单号" width="90"></el-table-column>
          <el-table-column sortable prop="transationNumber" label="微信订单号" width="120"></el-table-column>
        </el-table>
      </div>
    </div>
    <eb-pagination class="pagination" :current-page.sync="pageNumber" v-if="recordsTotal" @current-change="onPagination" :total="recordsTotal"
    />
  </div>
</template>
<script>
import ebHeader from '@/components/common/eb-header';
import ebBreakCrumb from '@/components/common/eb-break-crumb';
import ebSearch from '@/components/common/eb-search';
import ebPagination from '@/components/common/eb-pagination/eb-pagination';
import { sysBusinessList, businessConfig } from '@/services/busi/business-push-service';
import { baseURL } from '@/plugins/axios.js';
export default {
  name: 'BusiOpptyPushAdminList',
  components: {
    ebHeader,
    ebBreakCrumb,
    ebSearch,
    ebPagination
  },
  data() {
    return {
      user: this.$store.state.user.userInfo,
      tableData: [],
      requestData: {
        userId: this.$store.state.user.userInfo.userid,
        start: 1,
        length: 10,
        searchText: ''
      },
      recordsTotal: 0,
      pageNumber: 1,
      businessPushIds: [],
      isPushStatus: true,
      isOverdue: false
    };
  },
  created() {
    this.$root.layout.isLoading = false;
    this.initSysBusinessList();
  },
  methods: {
    async initSysBusinessList() {
      this.$root.layout.isLoading = true;
      try {
        let { data } = await sysBusinessList(this.requestData);
        if (data.returnCode === '01') {
          this.tableData = this.dataFilter(data.data);
          this.recordsTotal = data.recordsTotal;
        } else {
          this.$message.error('查询订阅列表失败');
        }
      } catch (error) {
        this.$message.error('查询订阅列表失败');
      }
      this.$root.layout.isLoading = false;
    },
    resetData: function() {
      this.requestData = {
        userId: this.user.userid,
        start: 1,
        length: 10,
        searchText: ''
      };
      this.recordsTotal = 0;
      this.pageNumber = 1;
      this.$refs.pushListRef.clearSelection();
      this.businessPushIds = [];
      this.isPushStatus = true;
      this.isOverdue = false;
    },
    searchData: function(val) {
      this.resetData();
      this.requestData.searchText = val;
      this.initSysBusinessList();
    },
    onPagination: function(result) {
      this.requestData.start = result;// (result - 1) * 10 > 0 ? (result - 1) * 10 : 0;
      this.initSysBusinessList();
    },
    dataFilter: function(data) {
      var arr = [];
      if (data) {
        arr = data.map(element => {
          if (element['pushStatus']) {
            element['pushStatus'] = this.$options.filters['pushStatus'](element['pushStatus']);
          }
          if (element['pushStartDate']) {
            element['pushStartDate'] = this.$options.filters['dateTimeStandardFormatOblique'](element['pushStartDate']);
          }
          if (element['pushEndDate']) {
            element['pushEndDate'] = this.$options.filters['dateTimeStandardFormatOblique'](element['pushEndDate']);
          }
          return element;
        });
      }
      return arr;
    },
    handleSelectionChange: function(rows) {
      this.businessPushIds = [];
      this.isPushStatus = true;
      this.isOverdue = false;
      if (rows.length > 0) {
        this.isPushStatus = false;
        rows.forEach(element => {
          if (element.pushStatus === '到期') {
            this.isOverdue = true;
          } else {
            this.businessPushIds.push(element.businessPushId);
          }
        });
      }
    },
    async onBusinessConfig(pushStatus) {
      this.isPushStatus = true;
      if (this.businessPushIds.length > 0) {
        try {
          let businessPushIds = this.businessPushIds.join(',');
          let { data } = await businessConfig({ businessPushIds: businessPushIds, pushStatus: pushStatus });
          if (data.returnCode === '01') {
            if (this.isOverdue) {
              this.$notify.error({
                title: '错误',
                message: '到期的未设置成功'
              });
            }
            this.$message.success('设置信息接收状态成功');
            this.resetData();
            this.initSysBusinessList();
          } else {
            this.$message.error('设置信息接收状态失败');
          }
        } catch (error) {
          this.$message.error('设置信息接收状态失败');
        }
      } else {
        if (this.isOverdue) {
          this.$notify.error({
            title: '错误',
            message: '到期的无法设置状态'
          });
        } else {
          this.$message.error('请选择订购企业');
        }
      }
    },
    downloadCsv: function() {
      window.open(baseURL + '/api/businessPush/sysBusinessList.csv');
    }
  }
};
</script>
<style scoped lang="less">
.button-group {
  display: flex;
  justify-content: flex-end;
  padding-right: 47px;
  padding-top: 30px;
}
</style>
